import {Moment} from 'moment';
import {Card, CardActionArea, Divider, Stack, SxProps, Typography} from '@mui/material';

const cardSx: SxProps = {
  width: '100%',
  borderRadius: '5px',
  boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.15)',
};

const cardActionAreaSx: SxProps = {
  '&:hover': {
    backgroundColor: 'var(--dcm-blue-lighter)',
  },
};

const cardRowSx: SxProps = {
  padding: '10px 20px 10px 12px',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderLeftWidth: '7px',
  borderLeftStyle: 'solid',
};

const dayBeforeSx: SxProps = {
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '20px',
  color: 'var(--dcm-gray-input)',
};

const textSx: SxProps = {
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '20px',
  color: 'var(--dcm-gray)',
};

const dividerSx: SxProps = {
  width: '1px',
  height: '36px',
  borderColor: 'var(--dcm-gray-general)',
  marginX: '20px',
};

export interface BaseShiftCardProps {
  borderColor: string;
  startHour: Moment;
  endHour: Moment;
  preLabel?: string;
  label: string;
  onClick?: () => void;
}

export function BaseShiftCard(props: BaseShiftCardProps) {
  return (
    <Card sx={cardSx}>
      <CardActionArea sx={cardActionAreaSx} onClick={props.onClick}>
        <Stack sx={{...cardRowSx, borderLeftColor: props.borderColor}}>
          <Stack flexDirection="column">
            {props.preLabel && (
              <Typography sx={dayBeforeSx} noWrap>
                {props.preLabel}
              </Typography>
            )}
            <Typography sx={textSx} noWrap>
              {props.label}
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" flexShrink={0}>
            <Divider orientation="vertical" sx={dividerSx} />
            <Typography sx={textSx} noWrap>
              {props.startHour.format('HH:mm')} - {props.endHour.format('HH:mm')}
            </Typography>
          </Stack>
        </Stack>
      </CardActionArea>
    </Card>
  );
}
